import React, { useState, useEffect } from "react";
import axios from "axios";
import DataTable from "../../Student/Reusablecomponents/DataTable/DataTable";
import Loading from "../../Student/Reusablecomponents/Loading";
import { useSelector, useDispatch } from "react-redux";
import {
  QBSubjectnames,
  CheckLanguage,
} from "../../ReusableComponents/CommonFunctions";
import SubHeadersDataTable from "../../Student/Reusablecomponents/DataTable/SubHeadersDataTable";
import { useNavigate, useLocation } from "react-router-dom";
const QBDashboard = (props) => {
  const navigate = useNavigate();
  const location = useLocation();

  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const SelectLanguage = useSelector(
    (state) => state.SelectLanguageData.SLanguage
  );
  const qbstatuscolumns = [
    { name: "Grade", selector: "grade", sortable: true },
    { name: "Target", selector: "totalTarget", sortable: true },
    { name: "Status", selector: "totalStatus", sortable: true },
    { name: "% Achievement", selector: "totalAchievement", sortable: true },
  ];

  const scenarioscountcolumns = [
    { name: "Subject", selector: "subject", sortable: true },
    { name: "No of Scenarios", selector: "noOfScenarios", sortable: true },
  ];

  const QCountcolumns = [
    { name: "Subject", selector: "subject", sortable: true },
    {
      name: "No of Questions",
      subColumns: [
        { name: "MCQ", selector: "mcq", sortable: true },
        { name: "NON-MCQ", selector: "nonmcq", sortable: true },
        { name: "Total Questions", selector: "totalQuestions", sortable: true },
        {
          name: "MCQ Questions used in the tests",
          selector: "usedQuestions",
          sortable: true,
        },
        {
          name: "MCQ Questions remaining to be used in tests",
          selector: "availableQuestions",
          sortable: true,
        },
      ],
    },
    {
      name: "Questions Mapped to Assessment Framework (Grade wise)",
      subColumns: [
        { name: "1", selector: "grade1", sortable: true },
        { name: "2", selector: "grade2", sortable: true },
        { name: "3", selector: "grade3", sortable: true },
        { name: "4", selector: "grade4", sortable: true },
        { name: "5", selector: "grade5", sortable: true },
        { name: "6", selector: "grade6", sortable: true },
        { name: "7", selector: "grade7", sortable: true },
        { name: "8", selector: "grade8", sortable: true },
        { name: "9", selector: "grade9", sortable: true },
        { name: "10", selector: "grade10", sortable: true },
        { name: "11", selector: "grade11", sortable: true },
        { name: "12", selector: "grade12", sortable: true },
        {
          name: "Total",
          sortable: true,
          cell: (row) => <div>{CountQuestions(row)}</div>,
        },
        {
          name: "%",
          sortable: true,
          cell: (row) => {
            const percentage = (CountQuestions(row) / row.totalQuestions) * 100;
            return (
              <div>
                {percentage % 1 === 0
                  ? percentage.toFixed(0)
                  : percentage.toFixed(2)}
                %
              </div>
            );
          },
        },
      ],
    },
    {
      name: "Questions Mapped to Remediation",
      subColumns: [
        { name: "Total", selector: "remMappedCount", sortable: true },
        {
          name: "%",
          selector: "remMappedPercent",
          sortable: true,
          cell: (row) => <div>{row.remMappedPercent}% </div>,
        },
      ],
    },
  ];
  const CountQuestions = (row) => {
    return (
      (row.grade1 || 0) +
      (row.grade2 || 0) +
      (row.grade3 || 0) +
      (row.grade4 || 0) +
      (row.grade5 || 0) +
      (row.grade6 || 0) +
      (row.grade7 || 0) +
      (row.grade8 || 0) +
      (row.grade9 || 0) +
      (row.grade10 || 0) +
      (row.grade11 || 0) +
      (row.grade12 || 0)
    );
  };
  const QVSColumns = [
    { name: "Questions Source", selector: "qSource", sortable: true },
    { name: "Total Questions", selector: "totalQuestions", sortable: true },
    { name: "Authoring", selector: "authoring", sortable: true },
    { name: "Verify", selector: "verify", sortable: true },
    { name: "Correction", selector: "correction", sortable: true },
    { name: "Re-Verify", selector: "reVerify", sortable: true },
    { name: "Completed", selector: "completed", sortable: true },
  ];
  const QBMembersColumns = [
    { name: "QB Admin Login", selector: "loginId", sortable: true },
    {
      name: "Total Questions",
      selector: "totalQuestions",
      sortable: true,
      cell: (row) => (
        <div
          className={row.totalQuestions && "LinkStyles"}
          onClick={() => {
            row.totalQuestions && NVerifyStatus(0, row.createdBy);
          }}
        >
          {row.totalQuestions}{" "}
        </div>
      ),
    },
    {
      name: "Authoring",
      selector: "authoring",
      sortable: true,
      cell: (row) => (
        <div
          className={row.authoring && "LinkStyles"}
          onClick={() => {
            row.authoring &&
              NVerifyStatus(
                QVCode.find((item) => item.lovDescription === "Authoring")
                  ?.lovId,
                row.createdBy
              );
          }}
        >
          {row.authoring}{" "}
        </div>
      ),
    },
    {
      name: "Verify",
      selector: "verify",
      sortable: true,
      cell: (row) => (
        <div
          className={row.verify && "LinkStyles"}
          onClick={() => {
            row.verify &&
              NVerifyStatus(
                QVCode.find((item) => item.lovDescription === "Verify")?.lovId,
                row.createdBy
              );
          }}
        >
          {row.verify}{" "}
        </div>
      ),
    },
    {
      name: "Correction",
      selector: "correction",
      sortable: true,
      cell: (row) => (
        <div
          className={row.correction && "LinkStyles"}
          onClick={() => {
            row.correction &&
              NVerifyStatus(
                QVCode.find((item) => item.lovDescription === "Correction")
                  ?.lovId,
                row.createdBy
              );
          }}
        >
          {row.correction}{" "}
        </div>
      ),
    },
    {
      name: "Re-Verify",
      selector: "reVerify",
      sortable: true,
      cell: (row) => (
        <div
          className={row.reVerify && "LinkStyles"}
          onClick={() => {
            row.reVerify &&
              NVerifyStatus(
                QVCode.find((item) => item.lovDescription === "Re-verify")
                  ?.lovId,
                row.createdBy
              );
          }}
        >
          {row.reVerify}{" "}
        </div>
      ),
    },
    {
      name: "Completed",
      selector: "completed",
      sortable: true,
      cell: (row) => (
        <div
          className={row.completed && "LinkStyles"}
          onClick={() => {
            row.completed &&
              NVerifyStatus(
                QVCode.find((item) => item.lovDescription === "Completed")
                  ?.lovId,
                row.createdBy
              );
          }}
        >
          {row.completed}{" "}
        </div>
      ),
    },
  ];
  const NVerifyStatus = (Value, CreatedId) => {
    navigate("/QBAdmin/OverallDashboard/VerificationSTatus", {
      state: { Tab: location.state?.Tab, QVS: Value, CreatedBy: CreatedId },
    });
  };
  const [QBStatusDetails, SetQBStatusDetails] = useState();
  const [ScenariosCount, SetScenariosCount] = useState();
  const [QuestionsCount, SetQuestionsCount] = useState();
  const [QVStatus, SetQVStatus] = useState();
  const [QVCode, SetQVCode] = useState();
  const [QBMembers, SetQBMembers] = useState();
  const [Load, SetLoad] = useState(false);

  useEffect(() => {
  const loadDashboard = async () => {
    try {
      SetLoad(true);

      const promises = [
        GetQVStatus(),
        GetQuestionVerificationcode(),
        GetQBMemberList(),
      ];

      if (!CheckLanguage(parseInt(SelectLanguage))) {
        promises.push(
          GetQBStatusByCategory(),
          GetQuestionsCount()
        );

        if (location.state?.Tab !== "DQ") {
          promises.push(GetScenariosCount());
        }
      }
      await Promise.all(promises);
    } catch (err) {
      console.error(err);
    } finally {
      SetLoad(false);
    }
  };

  loadDashboard();
}, [location.state?.Tab, SelectLanguage]);

  const GetQBStatusByCategory = async () => {
   const res = await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/QuestionBank/GetQuestionBankStats?QBCategoryCode=${location.state?.Tab}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
        const MathSub = res.data.filter((mathsc) =>
          mathsc.subject.includes(QBSubjectnames(items?.subjectId))
        );
        const Total = {
          grade: "Total",
          totalTarget: MathSub.reduce((sum, item) => sum + item.totalTarget, 0),
          totalStatus: MathSub.reduce((sum, item) => sum + item.totalStatus, 0),
          totalAchievement: Math.ceil(
            (MathSub.reduce((sum, item) => sum + item.totalStatus, 0) /
              MathSub.reduce((sum, item) => sum + item.totalTarget, 0)) *
              100
          ) || 0,
        };
        SetQBStatusDetails([...MathSub, Total]);
       
  };

  const GetScenariosCount = async () => {
   const res = await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/QuestionBank/GetOverallDashbaordScenariosCount?QBCategoryCode=${location.state?.Tab}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
        SetScenariosCount(
          res.data.filter((mathsc) =>
            mathsc.subject.includes(QBSubjectnames(items?.subjectId))
          )
        );
           SetLoad((prev) => !prev);
   
  };

  const GetQuestionsCount = async () => {
  const res = await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/QuestionBank/GetOverallDashbaordQuestionsCount?QBCategoryCode=${location.state?.Tab}&SubjectId=${items?.subjectId}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
        SetQuestionsCount(
          res.data.filter((mathsc) =>
            mathsc.subject.includes(QBSubjectnames(items?.subjectId))
          )
        );
        GetQVStatus();
   
  };

  const GetQVStatus = async () => {
   const res = await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/QuestionBank/GetQCountsByQStatusAndQSource?QBCategoryCode=${location.state?.Tab}&SubjectId=${items?.subjectId}&LanguageId=${SelectLanguage}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
        SetQVStatus(res.data);
     
  };

  const GetQBMemberList = async () => {
  const res = await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/QuestionBank/GetQCountsByQStatusAndQBMember?QBCategoryCode=${location.state?.Tab}&SubjectId=${items?.subjectId}&LanguageId=${SelectLanguage}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
        SetQBMembers(res.data);
     
  };

  const GetQuestionVerificationcode = async () => {
   const res = await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=0&LovCategoryId=45&ParentLovId=0`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
        SetQVCode(res.data);
    
  };

  return (
    <>
      {!CheckLanguage(parseInt(SelectLanguage)) && (
        <>
          <div className="SubHeading">QB Status</div>
          <div className="Card mt-2">
            {QBStatusDetails ? (
              <DataTable
                data={QBStatusDetails}
                columns={qbstatuscolumns}
                // Dropdownvalues={["10", "15", "20"]}
                className="NCLDataTable"
              />
            ) : (
              <div className="NoData-Message">
                {" "}
                {process.env.REACT_APP_Nodata_Found}{" "}
              </div>
            )}
          </div>
          {location.state?.Tab !== "DQ" && (
            <>
              <div className="SubHeading mt-3"> Scenarios Count </div>
              <div className="Card mt-2">
                {ScenariosCount ? (
                  <DataTable
                    data={ScenariosCount}
                    columns={scenarioscountcolumns}
                    Dropdownvalues={["10", "20", "50", "100"]}
                    className="NCLDataTable"
                  />
                ) : (
                  <div className="NoData-Message"> {process.env.REACT_APP_Nodata_Found} </div>
                )}
              </div>
            </>
          )}

          <div className="SubHeading mt-3">Questions</div>
          <div className="Card mt-2">
            {QuestionsCount ? (
              <SubHeadersDataTable
                data={QuestionsCount}
                columns={QCountcolumns}
                Dropdownvalues={["10", "20", "50", "100"]}
                className="NCLDataTable"
              />
            ) : (
              <div className="NoData-Message">
                {" "}
                {process.env.REACT_APP_Nodata_Found}{" "}
              </div>
            )}
          </div>
        </>
      )}
      <div className="SubHeading mt-3">
        Question Verification Status - Question Source wise
      </div>
      <div className="Card mt-2">
        {QVStatus ? (
          <DataTable
            data={QVStatus}
            columns={QVSColumns}
            Dropdownvalues={["10", "20", "50", "100"]}
            className="NCLDataTable"
          />
        ) : (
          <div className="NoData-Message">
            {" "}
            {process.env.REACT_APP_Nodata_Found}{" "}
          </div>
        )}
      </div>

      <div className="SubHeading mt-3">
        Question Verification Status - QB Admin
      </div>
      <div className="Card mt-2">
        {QBMembers ? (
          <DataTable
            data={QBMembers}
            columns={QBMembersColumns}
            Dropdownvalues={["10", "20", "50", "100"]}
            className="NCLDataTable"
            ShowPagination="true"
            ShowPagecount="true"
          />
        ) : (
          <div className="NoData-Message">
            {" "}
            {process.env.REACT_APP_Nodata_Found}{" "}
          </div>
        )}
      </div>

      {Load && <Loading />}
    </>
  );
};
export default QBDashboard;
